import { a as c, c as f } from "../lit-element-8JrrHldg.js";
import { S as l } from "../chunk.TLKDQ5JG-ClJ6bjhy.js";
import "../chunk.WLV3FVBR-BO0XtQ7O.js";
import "../chunk.TUVJKY7S-CZwfrQkU.js";
import "../chunk.UYAO2JRR-CUGf3xdB.js";
var a = l;
l.define("sl-spinner");
const m = ":host{--track-width: 12%;--track-color: rgba(107, 125, 145, .32);--indicator-color: var(--core-color-blue-800);--speed: 2.4s;--size: 24px;font-size:var(--size)!important}";
var v = Object.defineProperty, _ = Object.getOwnPropertyDescriptor, u = (i, e, t, s) => {
  for (var r = s > 1 ? void 0 : s ? _(e, t) : e, o = i.length - 1, p; o >= 0; o--)
    (p = i[o]) && (r = (s ? p(e, t, r) : p(r)) || r);
  return s && r && v(e, t, r), r;
};
let n = class extends a {
};
n.styles = [a.styles, c(m)];
n = u([
  f("pwc-spinner")
], n);
export {
  n as PwcSpinner
};
